module.exports = __webpack_public_path__ + "img/bguser.b21450ef.jpg";